﻿import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import definitions from '../../../Style/LfStyleDefinitions';
import {iconCode, mediaQuery, clearFix} from '../../../Style/cssHelpers';

import InsuranceHeading from './InsuranceHeading';
import StatusBlock from './StatusBlock';
import {ListingWrapper, Header, StatusCtaWrapper, StatusBlockColumn} from './statusBlockComponents';

import {getHealthDeclarationUrlForAction} from '../../../State/actions';

import {statusDefinitions, getRegistrationStatus} from '../PreregStatusDefs/status';

class SingleRegistration extends React.Component {
    static get propTypes() {
        return {
            registration: PropTypes.object.isRequired
        }
    }

    render() {
        const registration = this.props.registration; 
        const status = getRegistrationStatus(this.props.registration);

        return (
            <ListingWrapper>
                <Header>
                    <InsuranceHeading registration={registration} />
                </Header>
                <StatusCtaWrapper>
                    <StatusBlockColumn align="left">
                        <StatusBlock status={status}/>
                    </StatusBlockColumn>
                    <StatusBlockColumn align="right">
                        {status !== 'pending' &&
                            <DeclarationButton href={this.props.getHealthDeclarationUrlFor(registration.insuranceName, registration.insuranceObjectId)}>
                                {statusDefinitions[status].buttonCopy}
                            </DeclarationButton>
                        }
                    </StatusBlockColumn>
                </StatusCtaWrapper>
            </ListingWrapper>
        );   
    }
}

// state

const mapDispatchToProps = (dispatch) => {
    return {
        getHealthDeclarationUrlFor: (insuranceName, objId) => dispatch(getHealthDeclarationUrlForAction(insuranceName, objId))
    };
};

export default connect(() => ({}), mapDispatchToProps)(SingleRegistration);

// styles 

const DeclarationButton = styled.a`
    position: absolute; 

    width: auto; 
    right: 30px; 
    bottom: 40px;
    padding: 7px 20px 7px 20px;
    ${mediaQuery.xsmall(`
        position: relative; 
        display: inline-block;
        right: 0; 
        bottom: 0;
        padding: 7px 15px 7px 15px;
    `)}

    font-family: ${definitions.fonts.heading};
    font-size: 18px;
    ${mediaQuery.large(`
        font-size: 16px;
    `)}

    font-weight: bold;
    color: white; 
    
    background-color: ${definitions.colors.green};
    border-radius: 5px;

    transition: background-color 300ms ease-out; 

    &:hover, &:focus {
        text-decoration: none; 
        color: white;
    }
`;

